__turbopack_context__.v({
  "body": "gjlNBG_body",
  "closeButton": "gjlNBG_closeButton",
  "content": "gjlNBG_content",
  "footer": "gjlNBG_footer",
  "handle": "gjlNBG_handle",
  "handleRow": "gjlNBG_handleRow",
  "header": "gjlNBG_header",
  "listItem": "gjlNBG_listItem",
  "overlay": "gjlNBG_overlay",
  "title": "gjlNBG_title",
});
